import * as React from 'react';
import {RouteComponentProps} from "react-router";
import {LegQueryResult, useCreateLegMutation, useLegQuery, useUpdateLegMutation} from "../../../../types.d";
import {Form} from "@intelingu/core/components/form/Form";
import {FormGroup} from "../../../partials/form/elements/FormGroup";
import {Field} from "@intelingu/core/components/form/Field";
import {TextInput} from "../../../partials/form/elements/TextInput";
import {SubmitButton} from "../../../partials/form/elements/SubmitButton";
import {ImageField} from "../../../partials/form/elements/ImageField";
import {Link} from "react-router-dom";
import {IsNotEmpty} from "class-validator";

class Validator {

    @IsNotEmpty()
    postTitle: string;

}

export const UpdateLegPage = (props: RouteComponentProps<{ id: string, stage: string, language: string }>) => {
    const id = props.match.params.id !== 'create' ? Number(props.match.params.id) : null;
    let item: LegQueryResult;

    const [ createLeg, { data: createdLeg } ] = useCreateLegMutation();
    const [ updateLeg, { data: updatedLeg } ] = useUpdateLegMutation();

    if (id) {
        item = useLegQuery({
            variables: { id }
        });
    }

    if (item && !item.data) {
        return null;
    }

    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item"><Link to={`/courses/${props.match.params.language}`}>Courses</Link></li>
                    <li className="breadcrumb-item"><Link to={`/courses/${props.match.params.language}/stage/${props.match.params.stage}/legs`}>Legs</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">
                        { id ? `Leg ${item.data.leg.position}` : 'Create leg' }
                    </li>
                </ol>
            </nav>

            <Form
                validator={Validator}
                defaultData={item ? {
                    postTitle: item.data.leg.postTitle,
                    position: item.data.leg.position,
                    image: item.data.leg.imageId,
                    popupPicture: item.data.leg.popupPictureId,
                    imagePortrait: item.data.leg.imagePortraitId,
                } : {
                    stage: Number(props.match.params.stage),
                }}
                onSubmit={async (data, done) => {
                    if (id) {
                        await updateLeg({
                            variables: { id, input: data }
                        });
                    } else {
                        await createLeg({
                            variables: { input: data }
                        });
                    }

                    done();
                }}>

                <FormGroup label={'Title'} required={true}>
                    <Field
                        name={'postTitle'}
                        render={props => <TextInput {...props} />} />
                </FormGroup>

                <FormGroup label={'Position'}>
                    <Field
                        name={'position'}
                        render={props => <TextInput {...props} />} />
                </FormGroup>

                <FormGroup label={'Image'}>
                    <Field
                        name={'image'}
                        render={props => <ImageField
                            defaultPreview={item ? item.data.leg.image : null}
                            {...props} />} />
                </FormGroup>

                <FormGroup label={'Image Portrait'}>
                    <Field
                        name={'imagePortrait'}
                        render={props => <ImageField
                            defaultPreview={item ? item.data.leg.imagePortrait : null}
                            {...props} />} />
                </FormGroup>

                <FormGroup label={'Congratulation popup picture'}>
                    <Field
                        name={'popupPicture'}
                        render={props => <ImageField
                            defaultPreview={item ? item.data.leg.popupPicture : null}
                            {...props} />} />
                </FormGroup>

                <div className={'col-12'}>
                    <Field submit render={props => <SubmitButton {...props}>Done</SubmitButton>} />
                </div>
            </Form>
        </div>
    </div>
};
